// export const SERVER_URL = "http://localhost:6680";
// export const STRIPE_PK =
//   "pk_test_51IJ6Y4KNHmhlidyn2lvu0jNrtQ0suhJZ92dZlBnlXiJSPNyCKuf4Dh73Q4VCDZt8Y3LIWQdpcm5pVKKKfFWyfygZ00Kq4WkgX2";

  export const SERVER_URL = "https://rfmtools-api.troybroussard.com";
export const STRIPE_PK =
  "pk_test_51IJ6Y4KNHmhlidyn2lvu0jNrtQ0suhJZ92dZlBnlXiJSPNyCKuf4Dh73Q4VCDZt8Y3LIWQdpcm5pVKKKfFWyfygZ00Kq4WkgX2";
